<template>
    <BreadCrumb PageTitle="Liste mandature" />
    <ListeMandature/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeMandature from "@/components/Mandatures/ListeMandature.vue";
  
    export default defineComponent({
      name: "AddArticlePage",
      components: {
        BreadCrumb,
        ListeMandature,
      },
    });
  </script>